import React, { useEffect, useState } from 'react';
import Card from '../../components/ui/Card';
import Badge from '../../components/ui/Badge';
import SeparacaoDetail from './SeparacaoDetail';
import { pedidosApi } from '../../api/vendas';
import { STATUS_TOM, STATUS_LABEL } from '../vendas/PedidoDetail';
import { COLORS } from '../../theme';

function diasEmAberto(criadoEm) {
  const ms = Date.now() - new Date(criadoEm).getTime();
  return Math.max(Math.floor(ms / (1000 * 60 * 60 * 24)), 0);
}

export default function SeparacaoList() {
  const [pedidos, setPedidos] = useState([]);
  const [pedidoAberto, setPedidoAberto] = useState(undefined);

  const carregar = () => pedidosApi.filaSeparacao().then(setPedidos).catch(() => {});
  useEffect(() => { carregar(); }, []);

  if (pedidoAberto !== undefined) {
    return <SeparacaoDetail pedidoId={pedidoAberto} onVoltar={() => { setPedidoAberto(undefined); carregar(); }} />;
  }

  return (
    <div>
      <Card style={{ padding: 0, overflow: 'hidden' }}>
        <div style={{ padding: 14, borderBottom: `1px solid ${COLORS.border}` }}>
          <p style={{ margin: 0, fontSize: 13, color: COLORS.textMid }}>
            Pedidos aguardando ou em separação, do mais antigo pro mais novo.
          </p>
        </div>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ textAlign: 'left', background: COLORS.bg }}>
              <th style={{ padding: 10 }}>Nº Pedido</th>
              <th style={{ padding: 10 }}>Nº Proposta</th>
              <th style={{ padding: 10 }}>Cliente</th>
              <th style={{ padding: 10 }}>Vendedor</th>
              <th style={{ padding: 10 }}>Itens</th>
              <th style={{ padding: 10 }}>Data</th>
              <th style={{ padding: 10 }}>Dias em Aberto</th>
              <th style={{ padding: 10 }}>Status</th>
            </tr>
          </thead>
          <tbody>
            {pedidos.map(p => {
              const dias = diasEmAberto(p.criado_em);
              return (
                <tr key={p.id} onClick={() => setPedidoAberto(p.id)}
                  style={{ borderTop: `1px solid ${COLORS.border}`, cursor: 'pointer' }}>
                  <td style={{ padding: 10 }}>#{p.numero}</td>
                  <td style={{ padding: 10 }}>{p.proposta_numero ? `#${p.proposta_numero}` : '-'}</td>
                  <td style={{ padding: 10 }}>{p.cliente_nome}</td>
                  <td style={{ padding: 10 }}>{p.vendedor_nome}</td>
                  <td style={{ padding: 10 }}>{p.total_itens}</td>
                  <td style={{ padding: 10 }}>{new Date(p.criado_em).toLocaleDateString('pt-BR')}</td>
                  <td style={{ padding: 10, fontWeight: 600, color: dias >= 2 ? COLORS.danger : (dias >= 1 ? COLORS.warning : COLORS.textMid) }}>
                    {dias === 0 ? 'Hoje' : `${dias} dia${dias > 1 ? 's' : ''}`}
                  </td>
                  <td style={{ padding: 10 }}><Badge tom={STATUS_TOM[p.status]}>{STATUS_LABEL[p.status]}</Badge></td>
                </tr>
              );
            })}
            {pedidos.length === 0 && (
              <tr><td colSpan={8} style={{ padding: 20, textAlign: 'center', color: COLORS.textMid }}>Nenhum pedido aguardando separação.</td></tr>
            )}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
